export class Post {
    private readonly element: Element;

    constructor(element: Element) {
        this.element = element;
        this.init();
    }

    public highlightSearchQuery(): void {
        const
            nodes = this.element.querySelectorAll(`.is-searchable`),
            highlightedClass = `is-highlighted`;

        nodes.forEach((node) => {
            const text = node.innerHTML;
            node.innerHTML = text.replace(new RegExp("(" + this.getQuery() + ")", "i"), "<span class=" + highlightedClass + ">$1</span>");
        });
    }

    public getQuery(): string {
        return this.element.getAttribute(`data-query`);
    }

    protected init(): void {
        if (!this.getQuery() || !this.element) return;
        this.highlightSearchQuery();
    }
}